import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref } from "vue"
import _imports_0 from '@/assets.app/images/qr-code-download-app.svg'
import _imports_1 from '@/assets.app/images/google-play-store.svg'
import _imports_2 from '@/assets.app/images/apple-store.svg'


const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "layout__wrapper-inner container container--small" }
const _hoisted_3 = { class: "doc-preview" }
const _hoisted_4 = { class: "doc-preview__cover" }
const _hoisted_5 = { class: "doc-preview__info" }
const _hoisted_6 = { class: "doc-preview__content" }
const _hoisted_7 = { class: "doc-preview__title-box" }
const _hoisted_8 = {
  key: 1,
  class: "doc-preview__category"
}
const _hoisted_9 = { class: "doc-preview__title" }
const _hoisted_10 = {
  key: 2,
  class: "doc-preview__author doc-preview__author--flex"
}
const _hoisted_11 = { class: "doc-preview__author-inner" }
const _hoisted_12 = {
  key: 3,
  class: "doc-preview__author"
}
const _hoisted_13 = { class: "doc-preview__more" }
const _hoisted_14 = { class: "doc-preview__control-box" }
const _hoisted_15 = { class: "doc-preview__control-left icon-toolbar" }
const _hoisted_16 = { class: "doc-preview__control-right" }
const _hoisted_17 = {
  key: 0,
  class: "doc-preview__data-box"
}
const _hoisted_18 = { class: "doc-preview__about-box" }
const _hoisted_19 = { class: "doc-preview__about-title" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "doc-preview__additional-info-list" }
const _hoisted_22 = {
  key: 0,
  class: "doc-preview__additional-info doc-preview__additional-info--publish-date"
}
const _hoisted_23 = { class: "doc-preview__mobile-read-btn-box" }

import { ComputedRef, Ref, computed, onMounted, ref } from 'vue'
import { DocView } from '@/models/doc'

import { PodcastFollowView } from '@/models/docs.list.podcasts.episodes'

import { formatDate } from '@/helpers/time'
import Layout from '@/app/components/Layout.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import BackLink from '@/app/components/BackLink.vue'
import PreviewPageHighlights from '@/app/components/doc/preview/Highlights.vue'
import ProgressBar from '@/app/components/doc/preview/ProgressBar.vue'
import HeaderPreviewPage from '@/app/components/doc/preview/HeaderPreviewPage.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import DocListsMenu from '@/app/components/doc/DocListsMenu.vue'
import ExportBookButton from '@/app/components/doc/preview/ExportBookButton.vue'
import ContentLabel from '@/app/components/doc/ContentLabel.vue'
import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'
import PodcastFollowButton from '@/app/components/listing/PodcastFollowButton.vue'
import IconButton from '@/app/components/button/IconButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocPreviewPage',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const readingButton = computed(() => props.doc.startReadingButton())
const readLink = computed(() => props.doc.startLinkParams())

function hasTags(): ComputedRef<boolean> {
  return computed(() => {
    return props.doc.tags.length > 0
  })
}

const podcastFollowView: Ref<PodcastFollowView | null> = ref(null)

onMounted(() => {
  if (!props.doc.doc_group || !props.doc.isDocGroupFollowable()) {
    return
  }

  const docGroup = props.doc.doc_group
  podcastFollowView.value = new PodcastFollowView(
    docGroup.is_followed,
    docGroup.id,
  )
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Layout, {
    "hide-mobile-menu": "",
    class: "layout--doc-preview"
  }, {
    default: _withCtx(() => [
      _createVNode(HeaderPreviewPage, { doc: __props.doc }, null, 8, ["doc"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BackLink, { class: "doc-preview__backlink container container--small" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(BookCardThumbnail, {
                  doc: __props.doc,
                  class: "doc-preview__img-box",
                  coverClass: "doc-preview__img",
                  fallbackCoverClass: "doc-preview__img-fallback"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ProgressBar, { doc: __props.doc }, null, 8, ["doc"])
                  ]),
                  _: 1
                }, 8, ["doc"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (__props.doc.showAiLabel)
                      ? (_openBlock(), _createBlock(ContentLabel, {
                          key: 0,
                          class: "doc-preview__content-label"
                        }))
                      : (hasTags())
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(__props.doc.tags[0]), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("h1", _hoisted_9, _toDisplayString(__props.doc.title), 1),
                    (__props.doc.doc_group)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[0] || (_cache[0] = _createElementVNode("span", null, "By ", -1)),
                            _createVNode(_component_router_link, {
                              class: "doc-preview__author-text",
                              to: {
                          name: 'podcastPage',
                          params: {
                            url_slug: __props.doc.doc_group.url_slug,
                          },
                        }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.doc.doc_group.title), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          (podcastFollowView.value)
                            ? (_openBlock(), _createBlock(PodcastFollowButton, {
                                key: 0,
                                class: "doc-preview__follow-button",
                                view: podcastFollowView.value,
                                useLinkVariant: true
                              }, null, 8, ["view"]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_12, " By " + _toDisplayString(__props.doc.author), 1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(AppButton, {
                          class: "doc-preview__read-btn icon-toolbar__item",
                          tag: "router-link",
                          icon: readingButton.value.icon,
                          to: readLink.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(readingButton.value.text), 1)
                          ]),
                          _: 1
                        }, 8, ["icon", "to"]),
                        _createVNode(DocListsMenu, {
                          class: "doc-preview-favorite-btn icon-toolbar__item",
                          doc: __props.doc,
                          position: "center",
                          useIconButton: ""
                        }, null, 8, ["doc"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        (__props.doc.showDownload)
                          ? (_openBlock(), _createBlock(ExportBookButton, {
                              key: 0,
                              class: "doc-preview-download-btn icon-toolbar__item",
                              doc: __props.doc
                            }, null, 8, ["doc"]))
                          : _createCommentVNode("", true),
                        _createVNode(DocLibraryMenu, {
                          class: "doc-preview-actions-btn icon-toolbar__item",
                          doc: __props.doc
                        }, {
                          default: _withCtx(() => [
                            _createVNode(IconButton, {
                              icon: "imore",
                              tooltip: "Actions",
                              outlined: ""
                            })
                          ]),
                          _: 1
                        }, 8, ["doc"])
                      ])
                    ]),
                    (__props.doc.has_audio)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("div", { class: "doc-preview__data" }, [
                            _createElementVNode("span", { class: "doc-preview__data-icon iconfont iaudio" }),
                            _createElementVNode("span", { class: "doc-preview__data-text" }, "Audio available")
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "doc-preview__app" }, [
                _createElementVNode("div", { class: "doc-preview__app-text" }, "Install the App"),
                _createElementVNode("div", { class: "doc-preview__qr-code-box" }, [
                  _createElementVNode("img", {
                    class: "doc-preview__qr-code",
                    src: _imports_0,
                    alt: "QR code"
                  })
                ]),
                _createElementVNode("a", {
                  href: "https://play.google.com/store/apps/details?id=com.shortform.app",
                  target: "_blank",
                  class: "doc-preview__app-btn google-store-btn"
                }, [
                  _createElementVNode("img", {
                    class: "doc-preview__app-btn-img",
                    src: _imports_1,
                    alt: "Google Play"
                  })
                ]),
                _createElementVNode("a", {
                  href: "https://apps.apple.com/us/app/shortform/id1489472007",
                  target: "_blank",
                  class: "doc-preview__app-btn apple-store-btn"
                }, [
                  _createElementVNode("img", {
                    class: "doc-preview__app-btn-img",
                    src: _imports_2,
                    alt: "App Store"
                  })
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h2", _hoisted_19, _toDisplayString(__props.doc.aboutTitle), 1),
              _createElementVNode("div", {
                class: "doc-preview__about-text",
                innerHTML: __props.doc.blurb
              }, null, 8, _hoisted_20),
              _createElementVNode("ul", _hoisted_21, [
                (__props.doc.original_publish_date)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "doc-preview__additional-info-title" }, "Publish date:", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatDate)(__props.doc.original_publish_date)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(AppButton, {
                class: "doc-preview__read-btn icon-toolbar__item",
                tag: "router-link",
                icon: readingButton.value.icon,
                to: readLink.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(readingButton.value.text), 1)
                ]),
                _: 1
              }, 8, ["icon", "to"])
            ])
          ]),
          _createVNode(PreviewPageHighlights, { doc: __props.doc }, null, 8, ["doc"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})